import axios from 'axios';

import baseURL from '../../services/apiBaseUrl';

const TOKEN_KEY = 'gabbaiPortalToken';

export function getGabbaiToken() {
  return sessionStorage.getItem(TOKEN_KEY);
}

export function setGabbaiToken(token) {
  if (token) sessionStorage.setItem(TOKEN_KEY, token);
  else sessionStorage.removeItem(TOKEN_KEY);
}

export function clearGabbaiSession() {
  sessionStorage.removeItem(TOKEN_KEY);
}

const gabbaiApi = axios.create({
  baseURL,
  headers: { 'Content-Type': 'application/json' },
});

gabbaiApi.interceptors.request.use((config) => {
  const token = getGabbaiToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export async function requestGabbaiOtp(phone) {
  const { data } = await gabbaiApi.post('/gabbai-portal/request-otp', { phone });
  return data;
}

export async function verifyGabbaiOtp(phone, code) {
  const { data } = await gabbaiApi.post('/gabbai-portal/verify-otp', { phone, code });
  setGabbaiToken(data.token);
  return data;
}

export async function fetchGabbaiMe() {
  const { data } = await gabbaiApi.get('/gabbai-portal/me');
  return data;
}

export async function fetchGabbaiMeta() {
  const { data } = await gabbaiApi.get('/gabbai-portal/meta');
  return data;
}

export async function fetchGabbaiMembers(params = {}) {
  const { data } = await gabbaiApi.get('/gabbai-portal/members', { params });
  return data;
}

export async function fetchGabbaiMember(id) {
  const { data } = await gabbaiApi.get(`/gabbai-portal/members/${id}`);
  return data;
}

export async function saveGabbaiMemberRegistration(memberId, payload) {
  const { data } = await gabbaiApi.post(`/gabbai-portal/members/${memberId}/registration`, payload);
  return data;
}

export async function fetchGabbaiOrders(params = {}) {
  const { data } = await gabbaiApi.get('/gabbai-portal/orders', { params });
  return data;
}

export async function upsertGabbaiOrder(payload) {
  const { data } = await gabbaiApi.post('/gabbai-portal/orders', payload);
  return data;
}

export async function fetchGabbaiMessages() {
  const { data } = await gabbaiApi.get('/gabbai-portal/messages');
  return data;
}

export async function fetchGabbaiUpcomingExams() {
  const { data } = await gabbaiApi.get('/gabbai-portal/exams/upcoming');
  return data;
}

export default gabbaiApi;
